/**
 * faq.js — sections/faq.liquid only. Exclusive accordion (opening one item
 * closes the rest, matching the mockup's single-open UX) built on the
 * existing `.accordion__panel` grid-rows CSS motion contract (motion.css) —
 * this file only toggles `data-open` + `aria-expanded`, never animates
 * anything itself (CSS owns all transition/duration/easing).
 *
 * FAIL-SOFT: `data-open="false"` is the default markup state and every
 * panel's content is always present in the DOM (not removed), so with JS
 * disabled/broken the FAQ still reads as a plain, fully accessible list of
 * questions and answers — nothing is hidden behind a broken toggle.
 *
 * Loaded as `<script type="module" defer>` — no globals, no dependencies.
 */

const LOG_PREFIX = "[BecomeFounder]";

function initAccordion() {
  document.querySelectorAll("[data-faq-list]").forEach((list) => {
    const items = Array.from(list.querySelectorAll(".accordion__item"));

    items.forEach((item) => {
      const toggle = item.querySelector("[data-faq-toggle]");
      if (!toggle) return;

      toggle.addEventListener("click", () => {
        const isOpen = item.getAttribute("data-open") === "true";

        items.forEach((other) => {
          other.setAttribute("data-open", "false");
          const otherToggle = other.querySelector("[data-faq-toggle]");
          if (otherToggle) otherToggle.setAttribute("aria-expanded", "false");
        });

        if (!isOpen) {
          item.setAttribute("data-open", "true");
          toggle.setAttribute("aria-expanded", "true");
        }
      });
    });
  });
}

function init() {
  try {
    initAccordion();
  } catch (err) {
    console.warn(`${LOG_PREFIX} faq.js init failed — continuing without enhancement`, err);
  }
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", init);
} else {
  init();
}
